import { useQuery } from '@tanstack/react-query';
import { dashboard } from '../../api/payroll/dashboard';

export function useGetDashboard() {
  return useQuery(['dashboard'], () => {
    return dashboard.getDashboard();
  });
}
